import { render, staticRenderFns } from "./gallery.vue?vue&type=template&id=46b274f6&scoped=true"
import script from "./gallery.vue?vue&type=script&lang=js"
export * from "./gallery.vue?vue&type=script&lang=js"
import style0 from "./gallery.vue?vue&type=style&index=0&id=46b274f6&prod&lang=scss"
import style1 from "./gallery.vue?vue&type=style&index=1&id=46b274f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b274f6",
  null
  
)

export default component.exports